var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"p-title"},[_vm._v("数据告警")]),_c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.alarmData,"pagination":_vm.pagination}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }